import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { incomeExpenseMapActionType } from '../actions/actionTypes';

export const REDUCER_NAME = 'IncomeExpenseMapFilterList';

const updateFilterConfig = (state, action) => {
  if (action.data.systemDefault) {
    return {
      ...state,
      systemDefaultFilter: action.data.systemDefault || null,
      userDefaultFilter: action.data.userDefault || null,
      selectedFilter: action.data.selectedItem || null,
    };
  }
  if (action.data.userDefault === null || action.data.userDefault) {
    return {
      ...state,
      selectedFilter: action.data.selectedItem || null,
      userDefaultFilter: action.data.userDefault,
    };
  }
  return {
    ...state,
    selectedFilter: action.data.selectedItem || null,
  };
};

const logIEMListReq = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const updateTableConfig = (state, action) => ({
  ...state,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  listColumnOrder: action.data ? action.data.detail.columnOrders : null,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
  selectedFilter: action.data ? action.data : null,
});

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});

function IncomeExpenseMapFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // config list column configuration
    case incomeExpenseMapActionType.UPDATE_IEM_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case incomeExpenseMapActionType.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case incomeExpenseMapActionType.REMOVE_IEM_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    default:
      return null;
  }
}

function IncomeExpenseMapFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // log request
    case incomeExpenseMapActionType.LOG_IEM_LIST_REQUEST:
      return logIEMListReq(state, action);
    // log error
    case incomeExpenseMapActionType.GET_IEM_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    // store response
    case incomeExpenseMapActionType.GET_IEM_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case incomeExpenseMapActionType.GET_IEM_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case incomeExpenseMapActionType.RESET_IEM_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case incomeExpenseMapActionType.RESET_IEM_LOOKUPDATA:
      return {
        ...state,
        pageLevelLookupData: action.data,
      };
    case incomeExpenseMapActionType.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}
const IncomeExpenseMapFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = IncomeExpenseMapFilterListConfig(state, action);
  const stateReqRes = IncomeExpenseMapFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default IncomeExpenseMapFilterList;
